// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__381x8","footer__col1":"Footer_footer__col1__ArDvE"};